// extracted by mini-css-extract-plugin
export default {"photo":"EventSpeakers-module-f2b25b3126a69c6813a7","name":"EventSpeakers-module-e1900628fc4faaaca36e"};